import React, { Component } from "react";
import { Row, Modal, Button, Input, Col, Alert } from "reactstrap";
import Switch from "react-switch";
import LoadingOverlay from "react-loading-overlay";
import RequestManager from "../../singletons/RequestManager";
import config from "../../config";
import SelectSound from "../../components/SoundCard/SelectSound";
import ConfirmPrintRoll from "../../components/DetailedOrderCard/ConfirmPrintRoll";
import ChromePrint from "../../components/ChromePrint/ChromePrint";
import ErrorTokenMiss from "../../components/ErrorTokenMiss/ErrorTokenMiss";
import { SDK_CHROME_ELECTRON } from "../../config/Constants";
import { InlineShareButtons } from "sharethis-reactjs";
import { CopyToClipboard } from "react-copy-to-clipboard";
import DatePicker from "react-datepicker";
import moment from "moment";
import domtoimage from "dom-to-image";
import {generateHeaders, generateHeaderswithBasicAuthToken, generateEpochTimestamp, generateSignature} from "../../utils/helper";

var QRCode = require("qrcode.react");
let requestManager = new RequestManager();
export default class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      delivery : false,
      referenceStoreCode : null,
      closedTill: "",                // display value
      editingClosedTill: false,      // flag for editing mode
      tempClosedTill: "",            // temporary input value

      deliveryClosedTill: "",
      editingDeliveryClosedTill: false,
      tempDeliveryClosedTill: "",
        closedTillModalVisible: false,
  deliveryClosedTillModalVisible: false,
      loginMode: null,
      logOut: true,
      canStoreOpen: false,
      storeName: "",
      printSdkType: "",
      soundModalVisible: false,
      confirmModalVisible: false,
      chromePrintModalVisible: false,
      fontSize: 0,
      tokenMissmatchModalVisible: false,
      tokenErrorMessage: "",
      customUrl: "",
      customUrlFullString: "",
      customUrlOrginal: "",
      spinnerLoading: false,
      chromePrinters:"",
      fetchPrinterInfo:false,
      onePosMultiStore:false,
      subStores:[],
        // NEW:
  storeStatusLoaded: false,      // becomes true only after graphql fetch sets values
  storeStatusLoading: true,      // true while getStoreDetails is running
  storeStatusUpdating: false,    // true while update mutation is running

      
    };
  }
  componentWillMount() {
    this.setState({ spinnerLoading: true });
    this.checkLoginMode();
  
  }

  fetch_printer_info = async () =>{
    try{
      console.log('peri Printer-info fetchprinterinfo-3')
    var vtimestamp = generateEpochTimestamp();
      let response = await fetch(
        config.getPrinterinfo(),
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            test: "test"
            
          }),
        }
      );
      //console.log('peri Printer-info fetchprinterinfo-4')
      //console.log("peri Printer-info", response);

      if (response.status == 200) {
        try {
              let res = await response.json();
              console.log("peri Printer-info response", res);
              // console.log("KOT printer length", res.KOTPRINTER && res.KOTPRINTER.length);
              
              if (
                (res.KOTPRINTER && (Array.isArray(res.KOTPRINTER)) && res.KOTPRINTER.length > 0) &&
                (res.INVOICEPRINTER && (Array.isArray(res.INVOICEPRINTER)) && res.INVOICEPRINTER.length > 0)
              ) {
                this.setState({ chromePrinters: res });
                alert("Printers Fetched Sucessfully");
              } else {
                this.setState({ chromePrinters: {} });
                alert("Please select both KOT and Invoice Printers to Save");

              }
            } catch (error) {
              console.error("Error parsing response:", error);
              alert("Failed to fetch printer info. Please try again.");
              this.setState({ chromePrinters: {} });
            }
      }  
      
    } catch (error) {
      console.log("peri Printer-info error", error);
      // alert("Printer EXE Not Avaiable");
    }
  }
   // Handler to save printer data to localStorage
   handleSaveChromePrinters = async () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    console.log('this.state.chromePrinters', this.state.chromePrinters);
   
    let strPrinterJson = JSON.stringify(this.state.chromePrinters);
    if (this.state.loginMode === "store") {
      let input = {
        input: {
          id: storeInformation.store.id,
          chromePrinters:strPrinterJson,
          fetchPrinterInfo:false,
        },
      };
      console.log("Store Id", storeInformation.store.id);
      console.log("input", JSON.stringify(input));
      let response_updatePrinterInformation = await requestManager.getResponseFromPredefinedQuery(
        "updatePrinterInformation",
        input
      );
      console.log("Printer Status", response_updatePrinterInformation);
      
      if (response_updatePrinterInformation && response_updatePrinterInformation.data && response_updatePrinterInformation.data.updateStore && response_updatePrinterInformation.data.updateStore.store)
      {
        
        if(response_updatePrinterInformation.data.updateStore.store.fetchPrinterInfo===false)
        {
          this.state.fetchPrinterInfo = response_updatePrinterInformation.data.updateStore.store.fetchPrinterInfo;

        }
      
      }
     
    }
    // Optionally, display a success message (can be replaced with modal)
    this.toggleErrorTokenMissModal("Printers saved successfully.");
  };

  toggleErrorTokenMissModal = (text) => {
    this.setState({
      tokenMissmatchModalVisible: !this.state.tokenMissmatchModalVisible,
      tokenErrorMessage: text,
    });
  };
  toggleStorePrintRoll = async () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let loginMode = localStorage.getItem("loginMode");
    console.log("loginMode" + loginMode);
    if (loginMode === "store") {
      let input = {
        input: {
          id: storeInformation.store.id,
          isOpen: this.state.isOpen,
          printRollChange: "NEW_ROLL",
        },
      };

      let response = await requestManager.getResponseFromPredefinedQuery(
        "updateStoreStatus",
        input
      );
      console.log("response settings: " + JSON.stringify(response));
      if (response.error === null) {
      } else {
        alert(
          "Unable to update Store Status. Please check your internet connection."
        );
      }
    }
  };

  checkLoginMode = () => {
    let loginMode = localStorage.getItem("loginMode");
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));

    let storeName = "";
    if (loginMode === "store") {
      storeName = storeInformation.store && storeInformation.store.name;
    } else if (loginMode === "merchant") {
      storeName = storeInformation.merchant && storeInformation.merchant.name;
    } else if (loginMode === "concessionaire") {
      storeName = "Concessionaire";
    }
    let customUrl = "https://getnear.me/store/";
    if (storeInformation.store && storeInformation.store.customUrl !== null) {
      customUrl = customUrl + storeInformation.store.customUrl;
    }

    this.setState({
      //customUrlOrginal: storeInformation.store.customUrl,
      //customUrlFullString: customUrl,
      loginMode: loginMode,
      canStoreOpen:
        storeInformation.store && storeInformation.store.canMarkOpen,
      printSdkType:
        storeInformation.store && storeInformation.store.printSdkType,
      storeName: storeName,
    });
    console.log(loginMode);
    if (loginMode === "store") {
      this.getStoreDetails();
   
    }
  };



  toggleModal = () => {
    this.setState({
      soundModalVisible: !this.state.soundModalVisible,
    });
  };
  toggleConfirmPrintRollModal = () => {
    this.setState({
      confirmModalVisible: !this.state.confirmModalVisible,
    });
  };
  toggleSubStoreStatus = (index) => {
    this.setState((prevState) => {
        const updatedSubStores = prevState.subStores.map((store, i) =>
            i === index ? { ...store, open: !store.open } : store
        );

        // Get the updated store's code and open/close status
        const updatedStore = updatedSubStores[index];
        const openclose = updatedStore.open ? "OPEN" : "CLOSE";

        // Call setStoreOpenClose with storeCode and updated status
        //this.setStoreOpenClose(updatedStore.storeCode, openclose);
        // alert((updatedStore.storeCode))
        this.set_sub_stores_open_close(updatedStore.storeCode,openclose );
        return { subStores: updatedSubStores };
    });
};
 
//   toggleSubStoreStatus = (index) => {
//     this.setState((prevState) => ({
//         subStores: prevState.subStores.map((store, i) =>
//             i === index ? { ...store, open: !store.open } : store
//         )
//     }));
   
 
// };
  toggleChromePrintModal = () => {
    this.setState({
      chromePrintModalVisible: !this.state.chromePrintModalVisible,
    });
  };
  render() {
    const { spinnerLoading } = this.state;
    return (
      <LoadingOverlay
        style={{ width: "100%", height: "100%", zIndex: 999 }}
        active={spinnerLoading === true ? true : false}
        spinner
        text="Loading ..."
      >
        <div>
          <Modal
            size="lg"
            isOpen={this.state.tokenMissmatchModalVisible}
            toggle={this.toggleErrorTokenMissModal}
          >
            <ErrorTokenMiss
              editable={true}
              tokenErrorMessage={this.state.tokenErrorMessage}
              goBack={this.toggleErrorTokenMissModal}
            />
          </Modal>
          <Modal
            size="lg"
            isOpen={this.state.soundModalVisible}
            toggle={this.toggleModal}
          >
            <SelectSound goBack={this.toggleModal} />
          </Modal>
          <Modal
            size="lg"
            isOpen={this.state.confirmModalVisible}
            toggle={this.toggleConfirmPrintRollModal}
          >
            <ConfirmPrintRoll
              editable={true}
              settings={true}
              toggleStoreStatus={this.toggleStorePrintRoll}
              goBack={this.toggleConfirmPrintRollModal}
            />
          </Modal>

          <Modal
            size="lg"
            isOpen={this.state.chromePrintModalVisible}
            toggle={this.toggleChromePrintModal}
          >
            <ChromePrint goBack={this.toggleChromePrintModal} />
          </Modal>
          <Row
            style={{
              margin: 10,
              padding: 20,
              alignItems: "center",
              background: "white",
            }}
          >
            <div style={{ marginRight: 20 }}>
              {this.state.storeName + ": LOGOUT"}
              <p>{this.state.printSdkType !== undefined && this.state.printSdkType !== null ? this.state.printSdkType : ''}</p>
            </div>
            <Switch
              style={{ marginLeft: 20 }}
              onChange={(checked) => {
                this.logoutUser();
              }}
              checked={this.state.logOut}
            />
          </Row>

          {this.state.loginMode === "store" ? (
            this.state.canStoreOpen === true ? (
           <div>
            
              <Row
                style={{
                  margin: 10,
                  padding: 20,
                  alignItems: "center",
                  background: "white",
                }}
              >
                <div style={{ marginRight: 20 }}>
                  {this.state.isOpen === false
                    ? "Store CLOSED "
                    : "Store OPEN  "}
                </div>
                <Switch
                 disabled={
    !this.state.storeStatusLoaded ||
    this.state.storeStatusLoading ||
    this.state.storeStatusUpdating
  }
                  style={{ marginLeft: 20 }}
                  onChange={(checked, event, id) => {
                      if (
      !this.state.storeStatusLoaded ||
      this.state.storeStatusLoading ||
      this.state.storeStatusUpdating
    ) return;
                    this.toggleStoreStatus(checked);
                  }}
                  checked={this.state.isOpen}
                />
              </Row>
              
               <Row
                style={{
                  margin: 10,
                  padding: 20,
                  alignItems: "center",
                  background: "white",
                }}
              >
                <div style={{ marginRight: 20 }}>
                  {this.state.delivery === false
                    ? "Delivery CLOSED "
                    : "Delivery OPEN  "}
                </div>
                <Switch
                  style={{ marginLeft: 20 }}
                    disabled={
    !this.state.storeStatusLoaded ||
    this.state.storeStatusLoading ||
    this.state.storeStatusUpdating
  }
                  onChange={(checked, event, id) => {
  if (
      !this.state.storeStatusLoaded ||
      this.state.storeStatusLoading ||
      this.state.storeStatusUpdating
    ) return;

                    this.toggleStoreDeliveryStatus(checked);
                  }}
                  checked={this.state.delivery}
                />
              </Row>
            
             <Row style={{ marginLeft: "50px", padding: "20px" }}>
             
                {this.state.onePosMultiStore && this.state.subStores.length > 0 ? (
                  
                    <table border="10" cellPadding="10">
                        
                        <thead>
                          <tr><th>Sub Stores</th></tr>
                            <tr>
                                <th>Store Code</th>
                                <th>Store Name</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                          {console.log('subStores', this.state.subStores)}
                            {this.state.subStores.map((store, index) => (
                                <tr key={store.storeCode}>
                                    <td>{store.storeCode}</td>
                                    <td>{store.storeName}</td>
                                    <td>{store.open ? "OPEN" : "CLOSED"}</td>
                                    <td>
                                        <Switch
                                            style={{ marginLeft: 20 }}
                                            onChange={() => this.toggleSubStoreStatus(index)}
                                            checked={store.open}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                   null
                )}
           
                            </Row>
                
            
              
          </div>
            ) : null
          ) : null}
          {/* Show "Save Chrome Printers" button if printer data is not saved */}
          {console.log("FetchPrinterInfo",this.state.fetchPrinterInfo)};
          {this.state.fetchPrinterInfo === true &&  (
             <Row><Col
             style={{
               margin: 10,
               padding: 20,
               background: "white",
             }}
           >
             <Button
               color={"primary"}
               style={{ marginRight: 20, marginBottom: 10 }}
               onClick={this.fetch_printer_info}
             >
               {"Fetch Printers"}
             </Button>
           </Col>
          {/* {console.log('show save', this.state.chromePrinters)} */}
          {this.state.chromePrinters.KOTPRINTER &&
           (Array.isArray(this.state.chromePrinters.KOTPRINTER))  &&
      this.state.chromePrinters.KOTPRINTER.length > 0 &&
      this.state.chromePrinters.INVOICEPRINTER &&
      (Array.isArray(this.state.chromePrinters.INVOICEPRINTER))  &&
      this.state.chromePrinters.INVOICEPRINTER.length > 0 && (
        <Col
          style={{
            margin: 10,
            padding: 20,
            background: "white",
          }}
        >
          <Button
            color={"primary"}
            style={{ marginRight: 20, marginBottom: 10 }}
            onClick={this.handleSaveChromePrinters}
          >
            {"Save Printers"}
          </Button>
        </Col>
      )}
  
            </Row>
          )}
      
          {/* {this.state.printSdkType === SDK_CHROME_ELECTRON ? (
            <Col
              style={{
                margin: 10,
                padding: 20,
                background: "white",
              }}
            >
              <Button
                color={"primary"}
                style={{ marginRight: 20, marginBottom: 10 }}
                onClick={() => {
                  this.toggleChromePrintModal();
                }}
              >
                {"Select Printers List"}
              </Button>

              <Row style={{ margin: 10 }} className="center">
                <p style={{ width: "100%" }}>Pint KOT</p>
                <Input
                  type="number"
                  style={{ margin: 10, width: 200 }}
                  placeholder="Enter print font size."
                  onChange={(event) => {
                    this.setState({ fontSize: event.target.value });
                  }}
                />
                <Button
                  color={"primary"}
                  style={{ margin: 10, height: 38 }}
                  onClick={() => {
                    if (this.state.fontSize > 5) {
                      localStorage.setItem(
                        "gngPrinterFontSize",
                        this.state.fontSize
                      );
                      this.toggleErrorTokenMissModal("Successfully saved.");
                    } else {
                      this.toggleErrorTokenMissModal(
                        "Minimum font size should be 6."
                      );
                    }
                  }}
                >
                  {"Save"}
                </Button>
              </Row>
            </Col>
          ) : null} */}

          {/*this.state.loginMode === "store" ? (
            <Row
              style={{
                margin: 10,
                padding: 20,
                alignItems: "center",
                background: "white",
              }}
              onClick={() => {
                this.setState({ soundModalVisible: true });
              }}
            >
              <div style={{ marginRight: 20 }}>{"Select Sounds"}</div>
            </Row>
          ) : null*/}
          {/*this.state.loginMode === "store" ? (
            <Row
              style={{
                margin: 10,
                padding: 20,
                alignItems: "center",
                background: "white",
              }}
            >
              <Button
                color={"primary"}
                style={{ marginRight: 20 }}
                onClick={() => {
                  this.setState({ confirmModalVisible: true });
                }}
              >
                {"Reset Print Roll"}
              </Button>
            </Row>
          ) : null*/}
          {/*this.state.loginMode === "store" ? (
            <Row
              style={{
                margin: 10,
                padding: 20,
                alignItems: "center",
                background: "white",
              }}
            >
              <div style={{ marginRight: 20 }}>
                {"PrintSdkType: " + this.state.printSdkType}
              </div>
            </Row>
          ) : null*/}
        </div>
        
      </LoadingOverlay>
    );
  }
  checkStoreCustomUrl = async () => {
    this.setState({ spinnerLoading: true });
    if (this.state.loginMode === "store") {
      let customUrl = this.state.customUrl;
      let input = {
        customUrl: customUrl,
      };
      console.log();
      let response = await requestManager.getResponseFromPredefinedQuery(
        "checkStoreCustomUrl",
        input
      );
      console.log("checkStoreCustomUrl", JSON.stringify(response));
      if (response.error === null) {
        if (response.data.stores.edges.length > 0) {
          this.setState({ spinnerLoading: false });
          this.toggleErrorTokenMissModal("Already custom store url exist.");
        } else {
          this.toggleStoreCustomURL();
        }
      } else {
        this.setState({ spinnerLoading: false });
        alert(
          "Unable to update Store Status. Please check your internet connection."
        );
      }
    } else {
      this.setState({ spinnerLoading: false });
      alert("Unable to update Store Status.");
    }
  };
 toggleStoreStatus = async (status) => {
  if (this.state.storeStatusUpdating) return;
  const oldStatus = this.state.isOpen;
  const confirmMsg = status
    ? "Are you sure you want to OPEN the store?"
    : "Are you sure you want to CLOSE the store?";

  const confirmed = window.confirm(confirmMsg);
   if (!confirmed) {
    this.setState({ isOpen: oldStatus });
    return;
  }

  this.setState({ storeStatusUpdating: true });

  try {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    if (this.state.loginMode === "store") {
      let input = {
        input: {
          id: storeInformation.store.id,
          isOpen: status,
        },
      };

      let response = await requestManager.getResponseFromPredefinedQuery(
        "updateStoreStatus",
        input
      );

      if (response.error === null) {
        this.setState({ isOpen: status });
      } else {
        alert("Unable to update Store Status. Please check your internet connection.");
      }
    }
  } finally {
    this.setState({ storeStatusUpdating: false });
  }
};
toggleStoreDeliveryStatus = async (status) => {
  if (this.state.storeStatusUpdating) return;
  const olddeliveryStatus = this.state.delivery;

  const confirmMsg = status
    ? "Are you sure you want to OPEN the Delivery?"
    : "Are you sure you want to CLOSE the Delivery?";

  const confirmed = window.confirm(confirmMsg);
  if (!confirmed) {
    this.setState({ delivery: olddeliveryStatus });
    return;
  }

  this.setState({ storeStatusUpdating: true });

  try {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    if (this.state.loginMode === "store") {
      let input = {
        input: {
          id: storeInformation.store.id,
          delivery: status,
        },
      };

      let response = await requestManager.getResponseFromPredefinedQuery(
        "updateStoreStatus",
        input
      );

      if (response.error === null) {
        this.setState({ delivery: status });
      } else {
        alert("Unable to update Store Status. Please check your internet connection.");
      }
    }
  } finally {
    this.setState({ storeStatusUpdating: false });
  }
};


  getStoreDetails = async () => {
      this.setState({
    storeStatusLoading: true,
    storeStatusLoaded: false,
  });
    let params = {};
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getUserProfile", // Assuming this query returns the store details
      params
    );
    
    if (response.error) {
      // Handle error in fetching the store details
      alert("Something went wrong while fetching store details.");
    } else {
      let res = JSON.parse(JSON.stringify(response));
      console.log("getUserProfile", JSON.stringify(res.data));
  
      if (res.data.userProfile.user.store === null) {
        // Handle case where there is no store info (maybe show a message or reset UI)
         this.setState({ storeStatusLoading: false, storeStatusLoaded: false });
        return;
      } else {
        let customUrl = "https://getnear.me/store/";
        if (res.data.userProfile.user.store && res.data.userProfile.user.store.customUrl !== null) {
          customUrl = customUrl + res.data.userProfile.user.store.customUrl;
        }
  
        // Set store details and printer info in state
        this.setState({
          customUrlOrginal: customUrl,
          customUrlFullString: customUrl,
          isOpen: res.data.userProfile.user.store.isOpen,
          delivery : res.data.userProfile.user.store.delivery,
          referenceStoreCode : res.data.userProfile.user.store.referenceStoreCode,
          //chromePrinters: res.data.userProfile.user.store.chromePrinters, // Set the printers info
          fetchPrinterInfo: res.data.userProfile.user.store.fetchPrinterInfo,  // Flag that printer info is fetched
          onePosMultiStore: res.data.userProfile.user.store.onePosMultiStore,  // Flag that printer info is fetched
          //spinnerLoading: false,  // Hide loading spinner
            // NEW:
          storeStatusLoading: false,
          storeStatusLoaded: true,
          spinnerLoading: false, //  UNBLOCK UI
        });
        console.log("Fetched onePosMultiStore : ", res.data.userProfile.user.store.onePosMultiStore);
        if (res.data.userProfile.user.store.onePosMultiStore === true){
          this.get_sub_stores();
        }
       // console.log("Fetched Store and Printer Info: ", res.data.userProfile.user.store.chromePrinters);
        
        // if (res.data.userProfile.user.store.fetchPrinterInfo){
        //   console.log('peri Printer-info fetchprinterinfo-2')
        //   this.fetch_printer_info()
        // }
      }
    }
  };
  
  toggleStoreCustomURL = async () => {
    this.setState({ spinnerLoading: true });
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let loginMode = localStorage.getItem("loginMode");
    console.log("loginMode" + loginMode);
    let customUrl = this.state.customUrl;
    if (loginMode === "store") {
      let input = {
        input: {
          id: storeInformation.store.id,
          customUrl: customUrl,
        },
      };

      let response = await requestManager.getResponseFromPredefinedQuery(
        "updateStoreStatus",
        input
      );
      console.log("toggleStoreCustomURL settings: " + JSON.stringify(response));
      if (response.error === null) {
        this.setState({
          spinnerLoading: false,
          customUrlOrginal: customUrl,
          customUrlFullString: "https://getnear.me/store/" + customUrl,
        });
        this.toggleErrorTokenMissModal("Successfully updated.");
      } else {
        this.setState({ spinnerLoading: false });
        this.toggleErrorTokenMissModal(
          "Unable to update Store Status. Please check your internet connection."
        );
      }
    }
  };

get_sub_stores = async () => {
    console.log('inside get_sub_stores')
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let authToken = storeInformation.token;
    var vtimestamp = generateEpochTimestamp();
    // region_name
    try {
      let response = await fetch(
        config.getHost() + "/product/getsubstoresapi/",
        {
          method: "POST",
          headers: {
            Authorization: `Token ${authToken}`,
            "Content-Type": "application/json",
            Timestamp: vtimestamp,
            Signature: generateSignature(vtimestamp, authToken)               
          },
          body: JSON.stringify({
            store_id: storeInformation.store.id,
            graphql:true
          }),
        }
      );
      
      if (response.status === 200) {
        let json = await response.json();
        // let res = json.results;
        let res = [];
        if (json.results && Array.isArray(json.results) && json.results.length > 0) {
            if (Array.isArray(json.results[0]) && json.results[0].length > 0) {
                res = json.results[0][0]; // This assumes the expected structure
            }
        }
        console.log("res", res);
        this.setState({ subStores: res,loading:true });
        
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  set_sub_stores_open_close = async (n_store_code,n_openclose ) => {
    console.log('inside get_sub_stores')
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let authToken = storeInformation.token;
    var vtimestamp = generateEpochTimestamp();
    // region_name
    try {
      let response = await fetch(
        config.getHost() + "/product/setsubstoreopencloseapi/",
        {
          method: "POST",
          headers: {
            Authorization: `Token ${authToken}`,
            "Content-Type": "application/json",
            Timestamp: vtimestamp,
            Signature: generateSignature(vtimestamp, authToken)               
          },
          body: JSON.stringify({
            store_id: storeInformation.store.id,
            graphql:true,
            store_code : n_store_code,
            store_open: n_openclose
          }),
        }
      );
      
      if (response.status === 200) {
        let jsonres = await response.json();
        console.log("res", jsonres);
        
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  logoutUser = async () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let authToken = storeInformation.token;
    var vtimestamp = generateEpochTimestamp();   
    try{     
    await fetch(config.getHost() + "/api/account/logout", {
      method: "POST",
      headers: {
        Authorization: "Token " + authToken,
        Timestamp: vtimestamp,
        Signature: generateSignature(vtimestamp, authToken)              
      },
    });

    let requestManager = new RequestManager();
    requestManager.clearClient();
    console.log(JSON.stringify({ gngRemoveToken: "Y" }));
  }catch(error){
    console.log('logout error', error)
  }
    localStorage.removeItem("storeInformation");
    localStorage.removeItem("gngPrinterFontSize");
    localStorage.removeItem("reloadActive");

    localStorage.removeItem("attendedOrders");
    localStorage.removeItem("attendedSOSOrders");
    localStorage.removeItem("gngloginMode");
    localStorage.removeItem("gngtoken");
    localStorage.removeItem("GNGPrinters");
    localStorage.removeItem("loginMode");
    this.props.history.push("/login");
  };
}



// WEBPACK FOOTER //
// ./src/pages/Settings/Settings.js